<template>
  <div>
    <OnlineDriversWithoutTripsTable
      v-if="!loading"
      :service-type="serviceType"
      :data="data"
    />
    <base-overlay :show="loading">
      <b-card v-if="loading" />
      <b-card
        v-else
        style="cursor:pointer"
        @click="displayModalTable"
      >
        <div class="d-flex justify-content-between align-items-center">
          <h3 class="text-primary mb-0">
            Online Drivers
          </h3>
          <b-button
            variant="flat-primary"
            class="btn-icon rounded-circle"
            @click.prevent="fetch"
          >
            <feather-icon
              icon="RefreshCwIcon"
            />
          </b-button>
        </div>
        <h4 class="text-center mt-2">
          {{ totalCountOnlineWithNoTrips }}
        </h4>
      </b-card>
    </base-overlay>
  </div>
</template>

<script>
import {
  BCard, BButton,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import OnlineDriversWithoutTripsTable from './OnlineDriversWithoutTripsTable.vue'

export default {
  components: {
    BCard, BButton, OnlineDriversWithoutTripsTable,
  },
  props: {
    serviceType: {
      type: String,
      default: undefined,
    },
  },
  setup(props, ctx) {
    const data = ref(null)
    const totalCountOnlineWithNoTrips = ref(null)
    const loading = ref(false)
    const matchDriversWithNoCompletedTrips = (online, completed) => {
      let totalCount = 0
      const countByZones = {}
      online.hits.hits.forEach(hit => {
        const { id, zone } = hit.fields
        let driverId = null
        let currZone = null
        if (id && id.length) {
          const [x] = id
          driverId = x
        }
        if (zone && zone.length) {
          const [x] = zone
          currZone = x
        }
        if (driverId && currZone) {
          completed.forEach(c => {
            if (c.zone === currZone) {
              if (!c.values.includes(driverId)) {
                totalCount += 1
                if (!countByZones[c.zone]) {
                  countByZones[c.zone] = 1
                } else {
                  countByZones[c.zone] += 1
                }
              }
            }
          })
        }
      })
      return {
        totalCount,
        count: Object.entries(countByZones).map(([key, value]) => ({
          zone: key,
          count: value,
        })),
      }
    }
    const refactorCompletedDrivers = completed => completed.aggregations.by_zone.buckets.map(buck => ({
      zone: buck.key.split('::')[1],
      values: buck.driver_unique.buckets.map(el => el.key),
    }))
    const fetch = async () => {
      loading.value = true
      const res = await ctx.root.$store.dispatch('trips/getOnlineDrivers', {
        serviceType: props.serviceType,
      })
      const completedRes = refactorCompletedDrivers(res.completed_drivers_by_zone)
      const mappedData = matchDriversWithNoCompletedTrips(res.online_drivers, completedRes)
      data.value = mappedData.count
      totalCountOnlineWithNoTrips.value = mappedData.totalCount
      loading.value = false
    }
    const displayModalTable = () => {
      ctx.root.$bvModal.show(`${props.serviceType}-online-drivers-without-trips`)
    }
    fetch()
    return {
      loading,
      fetch,
      data,
      totalCountOnlineWithNoTrips,
      displayModalTable,
    }
  },
}
</script>

<style>

</style>
